import { convertWAVToMP3 } from 'helpers/audio';

const MediaRecorder = require('opus-media-recorder');
const EncoderWorker = require('worker-loader!opus-media-recorder/encoderWorker.js').default;
const OggOpusWasm = require('opus-media-recorder/OggOpusEncoder.wasm').default;
const WebMOpusWasm = require('opus-media-recorder/WebMOpusEncoder.wasm').default;

const options = { mimeType: 'audio/wav' }

const workerOptions = {
    encoderWorkerFactory: () => new EncoderWorker(),
    OggOpusEncoderWasmPath: OggOpusWasm,
    WebMOpusEncoderWasmPath: WebMOpusWasm
};

export class OpusMediaRecording {
    private isRecording = true;

    startedOn = ko.observable(new Date());
    endedOn = ko.observable<Date>();

    result: Promise<Blob>

    constructor(private recorder: MediaRecorder) {
        recorder.start();

        this.result = new Promise<Blob>((resolve, reject) => {
            recorder.addEventListener('dataavailable', async e => {
                try {
                    resolve(convertWAVToMP3(e.data));
                } catch (ex) {
                    reject(ex);
                }
            });
        });
    }

    finalize() {
        if (this.isRecording) {
            this.isRecording = false;

            this.recorder.stop();
            this.endedOn(new Date());

            this.recorder.stream.getTracks().forEach(i => i.stop());
        }

        return this.result;
    }
}

export default class OpusMediaRecorderManager {
    constructor() { }

    async startRecording() {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const recorder = new MediaRecorder(stream, options, workerOptions);

        return new OpusMediaRecording(recorder);
    }
}